
import React, { useState, useEffect } from "react";
import { Col, Row, Typography, Modal } from "antd";
import { useParams } from "react-router-dom";
import { getTestimonialDatabyId } from "../../../services/holiday/holidayServices";
import { PlayCircleOutlined } from "@ant-design/icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getImageUrl } from "../../../utils/Constants";

const { Title } = Typography;

const TestmonialVideo = () => {
  const { id } = useParams();
  const [testimonialData, setTestimonialData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [cleanedId, setCleanedId] = useState("");
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");

  useEffect(() => {
    if (id) {
      const cleaned = id.replace("-holiday-packages", "");
      setCleanedId(cleaned);
    }
  }, [id]);

  useEffect(() => {
    if (!cleanedId) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getTestimonialDatabyId("testimonial", cleanedId);

        const data = res?.data || res;
        if (Array.isArray(data)) {
          setTestimonialData(data);
        } else if (data) {
          setTestimonialData([data]);
        } else {
          setTestimonialData([]);
        }
      } catch (error) {
        setError(error.message || "Error while fetching testimonials");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cleanedId]);

  function getEmbedUrl(url) {
    if (!url) return "";

    let videoId = "";

    try {
      if (url.includes("youtube.com/shorts/")) {
        const parts = url.split("/shorts/");
        if (parts.length > 1) {
          videoId = parts[1].split("?")[0];
        }
      }
      else if (url.includes("youtube.com/watch?v=")) {
        const urlObj = new URL(url);
        videoId = urlObj.searchParams.get("v");
      }
      else if (url.includes("youtu.be/")) {
        videoId = url.split("/").pop().split("?")[0];
      }
      else if (url.includes("youtube.com/embed/")) {
        return url;
      }
      else if (url.includes("/shorts/")) {
        videoId = url.split("/shorts/")[1]?.split("?")[0];
      }
      if (videoId) {
        videoId = videoId.split("?")[0].split("&")[0];


        if (url.includes("shorts")) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
      }
    } catch (error) {
      console.error("Error parsing YouTube URL:", error);
    }

    return "";
  }

  const openVideoInModal = (url) => {
    if (!url) {
      console.log("No video URL provided");
      return;
    }

    console.log("Original URL:", url);

    const embedUrl = getEmbedUrl(url);

    if (embedUrl) {
      setSelectedVideoUrl(embedUrl);
      setIsModalOpen(true);
    } else {
      window.open(url, '_blank');
    }
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(4, testimonialData.length),
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, testimonialData.length),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, testimonialData.length),
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = (embedUrl) => {
    setSelectedVideoUrl(embedUrl);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedVideoUrl("");
  };

  const sliderData = testimonialData.length > 0
    ? [...testimonialData, ...testimonialData.slice(0, Math.max(0, 4 - testimonialData.length))]
    : [];

  console.log("testimonialData", testimonialData)
  return (
    <>
      {testimonialData?.length > 0 && (
        <section className="Testimonial-area ptb-70 bg-none">
          <div className="container">
            <div className="section-title">
              <div>
                <Title level={2} className="mb-0 offer-card__text box-title">
                  Customer Reviews
                </Title>
                <span className="top-title">
                  What our Customers Say About us
                </span>
              </div>
            </div>

            <Row gutter={20} className="justify-content-center">
              <Col md={24} xs={24}>
                <Slider {...settings}>
                  {testimonialData.map((item, index) => (
                    <div key={`${item.id || index}-${index}`}>
                      <div className="card mx-1 testimonial-card">
                        <div className="card-body">
                          <div
                            className="cursor-pointer video-thumbnail"
                            onClick={() => openVideoInModal(item?.video_url)}
                          >
                            {item?.image_url ? (
                              <div className="thumbnail-wrapper">
                                <img
                                  src={getImageUrl(item.image_url, "GALLERY")}
                                  alt={item.title}
                                  className="img-responsive rounded"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "https://via.placeholder.com/300x180?text=Video+Thumbnail";
                                  }}
                                />

                              </div>
                            ) : (
                              <div className="video-placeholder">
                                <PlayCircleOutlined className="placeholder-icon" />
                                <div className="placeholder-text">
                                  Click to watch testimonial
                                </div>
                              </div>
                            )}
                          </div>
                          <h3 className="mt-3">{item?.title}</h3>
                          {/* <p className="text-muted">
                            {item?.sub_title || item?.name || "Customer Testimonial"}
                          </p>
                          {item?.rating && (
                            <div className="rating">
                              {Array.from({ length: 5 }).map((_, i) => (
                                <span
                                  key={i}
                                  className={`star ${i < parseInt(item.rating) ? "filled" : ""
                                    }`}
                                >
                                  ★
                                </span>
                              ))}
                              <span className="rating-value">
                                {item.rating}/5
                              </span>
                            </div>
                          )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </Col>
            </Row>
          </div>
        </section>
      )}

      <Modal
        className="video_modal"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
        centered
        destroyOnClose
        closeIcon={
          <span className="modal-close-btn" aria-label="Close">
            ✕
          </span>
        }
      >
        <div className="modal-header">
          <h3>Customer Testimonial</h3>
        </div>
        <div className="video-wrapper">
          {selectedVideoUrl ? (
            <div className="video-container">
              <iframe
                src={selectedVideoUrl}
                title="Customer Testimonial Video"
                width="100%"
                height="450"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>
          ) : (
            <div className="no-video-message">
              <p>Video is not available at the moment.</p>
              <p>Please try again later.</p>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default TestmonialVideo;
